import { render, staticRenderFns } from "./AppConfirmAccount.vue?vue&type=template&id=21adc5f2&scoped=true&"
import script from "./AppConfirmAccount.vue?vue&type=script&lang=js&"
export * from "./AppConfirmAccount.vue?vue&type=script&lang=js&"
import style0 from "./AppConfirmAccount.vue?vue&type=style&index=0&id=21adc5f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21adc5f2",
  null
  
)

export default component.exports